import { render } from "./SeoManager.vue?vue&type=template&id=da318bbc"
import script from "./SeoManager.vue?vue&type=script&lang=js"
export * from "./SeoManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__